<div class="card-popover recurrencePopover card" *ngIf="Model">
    <div class="card-header highlightHeader">
        <div class="d-flex justify-content-between">
            <div class="statusIcon-Standard status-{{Model.Status}}"></div>
            <div>{{Model._RecurrencePattern}} | {{Model.CallDescription}}</div>
            <button type="button" class="close" aria-label="Close" (click)="Model = null">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
     </div>
        <div class="card-title">
            <div class="d-flex border-bottom p-3">
                <div class="d-flex w-auto">
                    <button *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DepartmentId, _AuthActionCodes.RecurrenceEdit) && Model.StatusCode == 'Y'" type="button" [disabled]="!ActivityLog.Result" (click)="EditRecurrence()" class="btn btn-secondary mr-2" translate>BTN.BTN_EDIT</button>
                    <a *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DepartmentId, _AuthActionCodes.RecurrencePrint)" href="/Pages/RecurrencePrint?RecurrenceID={{Model.RecurrenceId}}" target="_blank" class="btn btn-outline-secondary mr-2" translate>BTN.BTN_PRINT</a>
                    <button *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DepartmentId, _AuthActionCodes.RecurrenceRemove) && Model.StatusCode != 'D'" type="button" (click)="DeleteAlert()" class="btn btn-primary" translate>BTN.BTN_DELETE</button>
                </div>
            </div>
        </div>

        <div class="card-body">
            <div class="form-row form-group mt-2">
                <div class="col-4"><span class="lblDisplay" translate>LBL.START_DATE</span> <BR />{{Model.StartDateTime | amDateFormat: DateFormat}}</div>
                <div class="col-8"><span class="lblDisplay" translate>LBL.CALL_DESC</span><br />{{Model.CallDescription}}</div>
            </div>

            <div class="form-row form-group">
                <div class="col-4"><span class="lblDisplay" translate>LBL.LOCATION</span> <BR />{{Model.Location}}</div>
                <div class="col-8">
                    <span class="lblDisplay" translate>LBL.STATUS</span><BR />
                    <span class="badge badge-pill status-{{Model.Status}}">{{Model.StatusName | translate}}</span>
                </div>
            </div>

            <div class="form-row form-group">
                <div class="col-4"><span class="lblDisplay" translate>LBL.CATEGORY</span><BR />{{Model.Category}}</div>
                <div class="col-8"><span class="lblDisplay" translate>LBL.DEPARTMENT</span><br />{{Model.Department}}</div>
            </div>

            <div class="form-row form-group">
                <div class="col-4"><span class="lblDisplay" translate>LBL.END_PATTERN</span><br />{{Model._EndPattern}}</div>
                <div class="col-8"><span class="lblDisplay">{{'LBL.RECURRENCE_FREQUENCY' | translate}}</span><br />{{Model._RecurrenceFrequency}}</div>
            </div>
            <div class="form-row form-group">
                <div class="col-4"><span class="lblDisplay" translate>LBL.RECURRENCE_TYPE</span><br />{{Model._RecurrencePattern}}</div>
                <div class="col-8"><span class="lblDisplay" translate>LBL.REQUESTED_BY </span><br />{{Model.RequestedBy}}</div>
            </div>
            <div class="activity_log mt-2 item-aligns-center">
                <div class="row border-bottom mb-2">
                    <div class="col-auto">
                        <h4><span translate>LBL.ACTIVITY_LOG</span></h4>
                    </div>
                    <div class="col-auto ml-auto">
                        <div class="ml-2" *ngIf="ActivityLog && ActivityLog.TotalRecords > 0">
                            <ngb-pagination [collectionSize]="ActivityLog.TotalRecords"
                                            [maxSize]="3"
                                            [pageSize]="RecurrenceLookupModel.PageSize" [(page)]="RecurrenceLookupModel.PageNumber"
                                            [boundaryLinks]="true" (pageChange)="OnPageChange()" size="sm"></ngb-pagination>
                        </div>
                    </div>
                </div>

                <sk-wave [isRunning]="IsSubmitting"></sk-wave>
                <div *ngIf="IsSubmitting == false && ActivityLog.TotalRecords == 0" class="noRecords mb-5"><span translate>LBL.NO_RECORD_FOUND</span></div>
                <ul class="list-unstyled" *ngIf="IsSubmitting == false && ActivityLog">
                    <li *ngFor="let row of ActivityLog.Result" class="d-flex mb-3 border-bottom">
                        <div class="w-auto linebreak">
                            <div class="d-flex">
                                <span translate>LBL.RECURRED</span>: {{row.ActionDateTime | amDateFormat: DateFormat}}
                            </div>
                            <div class="d-flex align-items-center">
                                <div>{{'LBL.ACTION' | translate}}</div>:&nbsp;&nbsp;<div class="badge badge-secondary font-weight-bold pt-1">{{'LBL.'+row.Status | translate}}</div>
                            </div>
                            <div>
                                <span translate>LBL.JOB_NO_ASSOCIATED</span>: {{row.DisplayCallNo}}
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="row activity-pagination">
                    <div class="col-auto">
                        <div class="ml-2" *ngIf="ActivityLog && ActivityLog.TotalRecords > 0">
                            <ngb-pagination [collectionSize]="ActivityLog.TotalRecords"
                                            [maxSize]="3"
                                            [pageSize]="RecurrenceLookupModel.PageSize" [(page)]="RecurrenceLookupModel.PageNumber"
                                            [boundaryLinks]="true" (pageChange)="OnPageChange()" size="sm"></ngb-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modification-log mt-2 item-aligns-center">
                <div class="row border-bottom mb-2">
                    <div class="col-auto">
                        <h4><span translate>LBL.MODIFICATION_LOG</span></h4>
                    </div>
                </div>
                <sk-wave [isRunning]="IsSubmitting"></sk-wave>
                <div *ngIf="IsSubmitting == false && ModificationLog && ModificationLog.Result.length == 0" class="noRecords mb-5"><span translate>LBL.NO_RECORD_FOUND</span></div>
                <ul class="list-unstyled" *ngIf="IsSubmitting == false && ModificationLog && ModificationLog.Result">
                    <li *ngFor="let row of ModificationLog.Result" class="d-flex mb-3 border-bottom">
                        <div class="w-auto linebreak pb-2">
                            {{row.StartDateTime | amDateFormat: DateFormat}} - {{row._EndPattern}}<br />
                            {{'TITLE.TITLE_ROOM_STATUS' | translate}}: {{row._RoomStatus}}<br />
                            {{row._RecurrenceFrequency}}<br />
                            {{row.LastUpdate | amDateFormat: DateFormat}} {{row.Logger ? '-': ''}} {{row.LoggerName}}
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" translate>TITLE.TITLE_CONFIRM_DELETE</h4>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary" (click)="Delete()" translate>BTN.BTN_YES</button>
        <button type="button" class="btn btn-secondary" (click)="c('close')" translate>BTN.BTN_NO</button>
    </div>
</ng-template>
<RecurrenceUpdate #recurrenceUpdate (RecurrenceAdded)="RecurrenceChanged.emit(true);"></RecurrenceUpdate>
